import tw from "twin.macro"
import { useState } from "react"

import { TextBlockImageParagraphProps } from "components/dynamic"
import Section from "components/Section"
import { BodyCopy, BodyDetail, H4 } from "styles/Text"
import Image from "components/Image"
import PrimaryButton from "components/Buttons/Primary"
import Grid from "components/Grid"
import Column from "components/Column"
import HiddenIcon from "icons/Hidden"
import SecondaryButton from "components/Buttons/Secondary"
import Language from "components/Language"

const TextBlockImageParagraph = ({
  Anchor,
  Title,
  Body,
  _Image: ImageBlock,
  LinkButton,
  Reversed,
  SensitiveImage,
  ImageStyle,
  _ImageFocusHorizontal = "center",
  _ImageFocusVertical = "center",
}: TextBlockImageParagraphProps) => {
  const [revealed, setRevealed] = useState(false)
  return (
    <Section anchor={Anchor} gridSize={{ lg: 5 / 6 }}>
      <Grid
        halign="justify"
        valign="center"
        css={Reversed && tw`lg:flex-row-reverse`}
      >
        {ImageBlock?.url && (
          <Column size={{ md: 1 / 2 }}>
            <div tw="relative overflow-hidden">
              {SensitiveImage && !revealed && (
                <div tw="absolute inset-0 p-5 md:p-10 flex flex-col items-center justify-between text-center z-10 text-white bg-black bg-opacity-60">
                  <div />
                  <div>
                    <HiddenIcon tw="mb-5" />
                    <H4 tw="mb-2">Sensitive Content</H4>
                    <BodyCopy>
                      This photo contains sensitive content which some people
                      may find sensitive or disturbing
                    </BodyCopy>
                  </div>
                  <div>
                    <SecondaryButton
                      as="button"
                      type="button"
                      onClick={() => setRevealed(true)}
                    >
                      See Photo
                    </SecondaryButton>
                  </div>
                </div>
              )}
              <figure
                css={SensitiveImage && !revealed && { filter: "blur(20px)" }}
                tw="flex flex-col"
              >
                <Image
                  src={ImageBlock.url}
                  alt={ImageBlock.alternativeText}
                  objectFit={ImageStyle || "cover"}
                  objectPosition={[
                    _ImageFocusHorizontal,
                    _ImageFocusVertical,
                  ].join(" ")}
                  height={490}
                  width={490}
                />
                {ImageBlock?.caption && (
                  <BodyDetail as="figcaption" tw="text-dark-grey">
                    {ImageBlock.caption}
                  </BodyDetail>
                )}
              </figure>
            </div>
          </Column>
        )}

        <Column
          size={{ md: 1 / 2, lg: 5 / 12 }}
          tw="flex flex-col justify-center items-start mt-7.5 lg:mt-0"
        >
          {Title && (
            <H4 regular as="h2">
              <Language unwrap>{Title}</Language>
            </H4>
          )}
          {Body && <Language tw="mt-5 text-dark-grey">{Body}</Language>}
          {LinkButton?.Url && (
            <div tw="text-center md:text-left w-full">
              <PrimaryButton tw="mt-7.5" as="a" href={LinkButton.Url}>
                {LinkButton.Title}
              </PrimaryButton>
            </div>
          )}
        </Column>
      </Grid>
    </Section>
  )
}

export default TextBlockImageParagraph
